import React from 'react';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import Modal from 'components/Modal';
import {connect} from "react-redux";
import ShareableResourceSettings from "components/layout/shareable/ShareableResourceSettings";
import ShareableResourceUsers from "components/layout/shareable/ShareableResourceUsers";


class ShareEdition extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
    };
  }

  render() {
    const { intl, show, close, mayBeShared, listOfSharedUsers, editionId } = this.props;
    const messages = intl.messages;
    const data = { may_be_shared: mayBeShared }
    const mayRemove = true;

    return (
      <Modal show={show} onHide={close} bsSize="lg" enforceFocus={false}>
        <Modal.Header closeButton>
          <Modal.Title>{messages.share_edition}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <ShareableResourceSettings data={data} type={"edition"} id={editionId}/>
            <ShareableResourceUsers mayShare={mayBeShared} type={"edition"} id={editionId} mayRemove={mayRemove}/>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}


const mapStateToProps = state => {
  return {
    appIntl: state.intl,
  };
};

const mapDispatchToProps = dispatch => {
  return {
  };
};

export default withRouter(
  injectIntl(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(ShareEdition)
  )
);

